import { createAction } from '@ngrx/store';

export const userResendConfirmationEmailStart = createAction('USER/RESEND_CONFIRMATION_EMAIL_START');
export const userResendConfirmationEmailSuccess = createAction('USER/RESEND_CONFIRMATION_EMAIL_SUCCESS');
export const userResendConfirmationEmailFail = createAction('USER/RESEND_CONFIRMATION_EMAIL_FAIL');

export const userResetEntities = createAction('USER/RESET_ENTITIES');
